var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{class:_vm.show ? 'show' : 'none',attrs:{"id":"snackbar"}},[_vm._v(_vm._s(_vm.message))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }